import React from "react";
import PropTypes from "prop-types";
import {Controller} from "react-hook-form" ;
import ReactHookFormSingleFilePicker from "root/ReactHookForm/ui/ReactHookFormSingleFilePicker";

const SingleFilePicker = ({ validate, control, name, readOnly, options, ...rest }) =>
{
    return (
        <Controller
            control={control}
            name={name}
            defaultValue={[]}
            rules={{ required: false, validate: validate}}
            render={({ field: { onChange, value, name, ref },
                         fieldState: { invalid, isTouched, isDirty, error },
                         formState,
                     }) => (
                <ReactHookFormSingleFilePicker 
                    name={name} 
                    onChange={e => {
                        rest.unsetDocument && rest.unsetDocument();
                        onChange(e);
                    }} 
                    value={value} 
                    inputRef={ref} 
                    options={options} 
                    style={{display: "none"}}
                />
            )}
        />
    )
}

export default SingleFilePicker ;

SingleFilePicker.propTypes = {
    name: PropTypes.string.isRequired
};
